<template>
  <g opacity="0.4">
    <path
      d="M107.523 19.1546C101.756 13.155 94.8476 8.36978 87.2035 5.08052C79.5594 1.79127 71.3345 0.0644671 63.013 0.00177088C54.6915 -0.0609254 46.4416 1.54175 38.7488 4.71545C31.056 7.88916 24.0758 12.5698 18.2192 18.4817C-5.39539 42.288 -5.79501 81.0476 17.3017 105.339C27.447 116.024 41.0467 122.774 55.6918 124.393C70.3369 126.012 85.0824 122.395 97.3165 114.184L142.417 161.079C142.693 161.367 143.023 161.597 143.389 161.757C143.754 161.918 144.148 162.004 144.546 162.012C144.945 162.02 145.342 161.949 145.713 161.804C146.085 161.658 146.424 161.441 146.711 161.164L157.95 150.358C158.237 150.082 158.468 149.752 158.628 149.387C158.788 149.021 158.875 148.628 158.883 148.229C158.891 147.83 158.82 147.434 158.675 147.062C158.529 146.691 158.312 146.352 158.035 146.064L112.935 99.1694C121.581 87.3233 125.778 72.8099 124.788 58.1774C123.798 43.5449 117.686 29.7287 107.523 19.1546ZM93.4752 94.5615C87.1147 100.68 79.0827 104.775 70.3948 106.328C61.707 107.882 52.7536 106.825 44.6667 103.29C36.5799 99.7548 29.7229 93.9013 24.9628 86.4693C20.2028 79.0374 17.7534 70.3608 17.9245 61.5368C18.0956 52.7128 20.8794 44.1377 25.924 36.8958C30.9686 29.654 38.0473 24.0707 46.2651 20.8519C54.4829 17.6331 63.4706 16.9234 72.0916 18.8127C80.7127 20.7019 88.58 25.1051 94.6986 31.4655C98.7613 35.6887 101.952 40.6708 104.09 46.1273C106.227 51.5838 107.268 57.4078 107.155 63.2669C107.041 69.1259 105.775 74.9052 103.427 80.2747C101.08 85.6442 97.6986 90.4989 93.4752 94.5615Z"
      :fill="iconColor"
    />
    <path
      d="M29.4985 49.9747C24.4787 49.9747 24.4705 57.7715 29.4985 57.7715C34.5264 57.7715 34.5224 49.9747 29.4985 49.9747Z"
      :fill="iconColor"
    />
    <path
      d="M64.478 25.006C50.9723 24.7002 38.6777 31.4775 32.145 41.7251C30.0123 45.0607 36.0678 48.009 38.1883 44.6896C43.5996 36.22 53.8838 30.8251 64.9959 31.1228C76.6502 31.4164 87.2566 38.0836 92.8718 47.3361C95.0045 50.8471 100.583 47.6542 98.4665 44.1636C91.6525 32.9292 78.4322 25.3241 64.478 25.006Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
